module.exports = __webpack_public_path__ + "img/evergreen.5392063e.png";